import React, { FC } from 'react';
import { useParams } from 'react-router-dom';

import { ExperienceErrorBoundary } from '@/components/primitive/error-boundary';
import { PrimaryType } from '@/meta';
import { spaceTopComfortable } from '@/styles';

import SLOFilterBar from '../slo-filter-bar';

import DashboardBasicList from './dashboard-basic-list';

type DashboardSubEntityListProps = { entityType: PrimaryType | undefined; experienceSeq: number };

const DashboardSubEntityList: FC<DashboardSubEntityListProps> = ({ entityType, experienceSeq }) => {
  const { publicId: publicIdParam } = useParams<{ publicId: string }>();
  const publicId = publicIdParam ?? '';

  const type = entityType === 'team' ? 'product' : 'team';

  if (!entityType) return <></>;

  return (
    <ExperienceErrorBoundary>
      <div>
        <SLOFilterBar basicMode={entityType === 'product'} />
        <div css={spaceTopComfortable}>
          <DashboardBasicList experienceSeq={experienceSeq} type={type} id={publicId} />
        </div>
      </div>
    </ExperienceErrorBoundary>
  );
};

export default DashboardSubEntityList;
